export default "__VITE_ASSET__DJIEkB81__"